import { useState } from "react";
import { AcpOverview, AcpFeed, AcpSync } from "./AcpOverviewFeedSync";
import { AcpProducts } from "./AcpProducts";
import { AcpPromotions, AcpSettings } from "./AcpPromotionsSettings";

const SUBS = [["overview", "Overview"], ["products", "Products"], ["feed", "Feed"], ["promotions", "Promotions"], ["sync", "Sync"], ["settings", "Settings"]];

// Catalogue → ChatGPT tab: product/catalog side of the Agentic Commerce Protocol.
export default function ChatGptCommerceTab({ callerUserRecordId }) {
  const [sub, setSub] = useState("overview");
  return (
    <div data-testid="acp-tab">
      <div className="mb-3">
        <h1 className="text-xl font-bold text-zinc-900">ChatGPT Commerce</h1>
        <p className="text-sm text-zinc-500">Agentic Commerce Protocol (ACP)</p>
      </div>
      <div className="inline-flex flex-wrap rounded-xl bg-white border border-zinc-200 p-0.5 mb-4" data-testid="acp-subtabs">
        {SUBS.map(([k, l]) => (
          <button key={k} type="button" onClick={() => setSub(k)}
            className={`h-8 px-3 rounded-lg text-xs font-semibold transition ${sub === k ? "bg-zinc-900 text-white" : "text-zinc-700 hover:bg-zinc-50"}`}
            data-testid={`acp-subtab-${k}`}>{l}</button>
        ))}
      </div>
      {sub === "overview" && <AcpOverview caller={callerUserRecordId} />}
      {sub === "products" && <AcpProducts caller={callerUserRecordId} />}
      {sub === "feed" && <AcpFeed caller={callerUserRecordId} />}
      {sub === "promotions" && <AcpPromotions caller={callerUserRecordId} />}
      {sub === "sync" && <AcpSync caller={callerUserRecordId} />}
      {sub === "settings" && <AcpSettings caller={callerUserRecordId} />}
    </div>
  );
}
